import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { TTTOutCocModule } from '../models/TTTOutCocModule';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class TTTOutCocService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

  public getTTTOutCocAll(patcode: string ,ttttype:string , compcode: string) {

      let params = new HttpParams();
        params = params.append("PatCode", patcode);
        params = params.append("TTTType", ttttype);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<TTTOutCocModule[]>(this.urlsconfig.WebAPIURL_Test + 'api/TTToutCoc/GetTTToutCoc',options);
    }


    public AddTTTOutCoc(endoInv: TTTOutCocModule) {
      return this.http.post<TTTOutCocModule>(this.urlsconfig.WebAPIURL_Test + 'api/TTToutCoc/AddTTToutCoc', endoInv);
    }

    public delTTToutCoc_Line(patcode: string ,tttdate :string, ttttype:string , tttname:string, compcode: string) {

    let params = new HttpParams();
    params = params.append("PatCode", patcode);
    params = params.append("TTTType", ttttype)
    params = params.append("TTTDate", tttdate)
    params = params.append("TTTName", tttname);
    params = params.append("CompCode", compcode);


      const options = {
        params: params
    };
    return this.http.delete<TTTOutCocModule>(this.urlsconfig.WebAPIURL_Test + 'api/TTToutCoc/DeleteTTToutCoc',options);
    }


  }
